angular.module('zc.projects')

.filter 'segmentRelevantHeaders', ->
  IGNORED_HEADERS = [
    'id'
    'name'
    'description'
    'updated_at'
    'created_at'
    'segment_type'
    'message'
    'ruleView'
    'raw'
    'mongo_query'
    'creator'
    'last_updater'
    'updated_at'
    'created_at'
    'campaign_ids'
    'campaign_policy_set_id'
    'project_id'
    '$$hashKey'
  ]

  return (policies) ->
    _.chain(policies)
      .map((policy) ->
        nonempty = []

        for key, val of policy when typeof val isnt 'undefined'
          nonempty.push key

        if policy && policy.mongo_query
          mongo_query_headers = []
          for key, val of policy.mongo_query
            mongo_query_headers.push key
          nonempty = _.assignIn(nonempty, mongo_query_headers)

        nonempty
      )
      .flatten()
      .uniq()
      .remove((h) -> IGNORED_HEADERS.indexOf(h) < 0)
      .value()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/segment_relevant_headers.filter.coffee